import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { aiConfigItemMessages, aiMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';
import { SummarizeIcon } from '../../../../icons/prompt/summarize';
import { createInsertAtCurrentPosition, createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
export var summarizeWriting = {
  key: CONFIG_ITEM_KEYS.SUMMARISE_WRITING,
  title: aiConfigItemMessages.summarizeWritingtitle,
  description: aiConfigItemMessages.summarizeWritingDescription,
  icon: function icon() {
    return /*#__PURE__*/React.createElement(SummarizeIcon, null);
  },
  showInRefineDropdown: true,
  intentSchemaId: 'summarize_intent_schema.json',
  actions: {
    empty: [createInsertAtCurrentPosition({
      appearance: 'primary'
    })],
    selection: [createInsertBelow({
      appearance: 'secondary'
    }), createReplace({
      appearance: 'primary'
    })]
  },
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service') || fg('platform_editor_ai_assistance_service_second')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  }
};
export var summarizeWritingWithOptions = {
  config: summarizeWriting,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};
export var summarizeWritingWithOptionsForAtlas = {
  config: _objectSpread(_objectSpread({}, summarizeWriting), {}, {
    description: aiMessages.atlasSummarizePageConfigItemDescription
  }),
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: false
    }
  }
};